<div class="relative m-4">
  <!-- Only show arrows if more than 1 item -->
  @if (compareItems().length > 1) {
    <button
      (click)="scrollPrev()"
      [disabled]="!canScrollLeft()"
      class="md:hidden absolute left-2 top-60 -translate-y-1/2 z-10 bg-white rounded-full p-2 shadow-lg disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
      <app-icons icon="chevron-left"/>
    </button>

    <button
      (click)="scrollNext()"
      [disabled]="!canScrollRight()"
      class="md:hidden absolute right-2 top-60 -translate-y-1/2 z-10 bg-white rounded-full p-2 shadow-lg disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
      <app-icons icon="chevron-right"/>
    </button>
  }

  <div
    #scrollContainer
    class="flex md:justify-evenly gap-4 md:gap-12 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none scrollbar-hide">
    @for (item of compareItems(); track $index) {
      <div class="w-full md:w-1/4 shrink-0 snap-center">
        <div>
          <app-compare-item [level]="item.key" [item]="item.item"></app-compare-item>
        </div>
      </div>
    }
  </div>
</div>
